import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import {Button} from "@material-ui/core"
import { CONFIRMATION_MODAL_KEY, clearActiveModal, getActiveModal, getModalParams } from '../v2_actions/ui'
import { Separator } from './layout/Separator'
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles({
    buttons: {
        display: "flex"
    },
    confirmText: {
        padding: "10px"
    }
})

export const ConfirmationModal = () => {
    const dispatch = useDispatch()
    const classes = useStyles()
    const is_active = useSelector((state) => getActiveModal(state) === CONFIRMATION_MODAL_KEY)
    const { text, onConfirmed, can_cancel } = useSelector((state) => getModalParams(state))

    const onClose = () => {
        if ( is_active ) {
            dispatch(clearActiveModal())
        }
    }

    const onConfirm = () => {
        onConfirmed()
        onClose()
    }

    if ( ! is_active ) {
        return null
    }
    
    return (

        <Dialog open={true}
                onClose={onClose}
                aria-labelledby="customized-dialog-title"
        >
          <MuiDialogTitle>
            {text}
          </MuiDialogTitle>
          <Separator variant="h20" />
          <div >
            { can_cancel !== false && 
              <Button variant="danger" onClick={onClose}>
                Cancel
              </Button>
            }
            <Button variant="success" onClick={onConfirm}>
              Confirm
            </Button>
          </div>
        </Dialog>

    )
}
